<template>
  <v-radio-group
    v-bind="vuetifyOverrideMixin.bindings"
    class="sn-radio-group flex-grow-1"
    v-on="$listeners"
  >
    <slot />
  </v-radio-group>
</template>

<script>
import vuetifyOverrideMixin from '~/components/snui/v2/mixins/vuetifyOverrideMixin.vue'

export default {
  name: 'SnRadioGroup',
  mixins: [vuetifyOverrideMixin],
  inheritAttrs: true,
  // v-radio-group uses 'change' instead of the default 'input' event to track model changes
  // See https://github.com/vuetifyjs/vuetify/blob/75404fb66e61d4b4d5b759506ac0d4c7a56a3755/packages/vuetify/src/mixins/selectable/index.ts#L23
  model: { prop: 'value', event: 'change' },
  data () {
    return {
      vuetifyOverrideMixin: {
        defaultProps: {
          hideDetails: 'auto'
        },
        // Supported props: column, disabled, error, errorMessages, hideDetails, hint, id, mandatory, name, row, rules, validateOnBlur, value
        overriddenProps: {
          activeClass: 'v-item--active',
          appendIcon: undefined,
          backgroundColor: undefined,
          dark: false,
          dense: false,
          errorCount: 1,
          hideSpinButtons: true,
          label: undefined,
          light: false,
          max: undefined,
          messages: [],
          multiple: false,
          persistentHint: true,
          prependIcon: undefined,
          readonly: false,
          success: false,
          successMessages: [],
          tag: 'div',
          valueComparator: null
        },
        silencedPropWarnings: ['label']
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/components/snui/v2/mixins/vuetifyOverrideCss.scss';

.sn-radio-group {
  margin: 0px;
  padding: 0px;

  ::v-deep {
    .v-input__slot {
      margin: 0px;
    }

    .v-input--radio-group__input {
      justify-content: space-between;
      label {
        align-content: stretch;
      }
    }

    .v-messages {
      @extend .v-messages--sn_override;
    }
  }
}
</style>
